import { render, staticRenderFns } from "./newFooter.vue?vue&type=template&id=6b1448b7&scoped=true"
import script from "./newFooter.vue?vue&type=script&lang=js"
export * from "./newFooter.vue?vue&type=script&lang=js"
import style0 from "./newFooter.vue?vue&type=style&index=0&id=6b1448b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1448b7",
  null
  
)

export default component.exports